window.storedInterscrollerEl = null;

// Separate function to insert element at a specific index or append if index is out of bounds
function insertAtIndex(parentNode, newElement, index) {
  const children = parentNode.children;
  const targetIndex = Math.min(index, children.length - 1);

  // Insert or append based on the target index
  if (index >= children.length) {
    parentNode.appendChild(newElement); // Append if index is out of bounds
  } else {
    parentNode.insertBefore(newElement, children[targetIndex].nextSibling);
  }
}

function moveInterscroller() {
  const desiredPositionToBePutAfter = 3; // Desired position to be put after as a 1-based index
  const filmcontainerEl = document.getElementById("filmContainer");

  if (filmcontainerEl && desiredPositionToBePutAfter > 1) {
    const interscrollerEl = document.getElementById("banner-interscroller");

    // Store and remove the interscroller element if it exists
    if (interscrollerEl) {
      window.storedInterscrollerEl = interscrollerEl.parentNode.removeChild(interscrollerEl);
    }

    if (window.storedInterscrollerEl) {
      // Use insertAtIndex to place the stored element in the desired position
      insertAtIndex(filmcontainerEl, window.storedInterscrollerEl, desiredPositionToBePutAfter - 1);
    }
  }
}

// Attach event listeners
window.addEventListener("filmfilter_apply_filters_finished", moveInterscroller);
window.addEventListener("vue-movie-listing-filters-applied", moveInterscroller);
